import { GetServerSidePropsContext } from 'next';
import { Configuration } from '../../graphql/Services';
import article from '../../graphql/Services/Article/queries/article';
import { ssrPersistedQuery, isMaintenance, set503Header, setDefaultCacheHeader, setNoCacheHeader, transformSeoToMetas } from '../../helpers/SSRHelpers';
import { initWithLangAndLabels } from '../../i18n';
import routes from '../../routes/definitions';
import Router from '../../routes/Router';
import { ArticlePage, ArticlePageProps } from '../../relay/ArticlePage';
import { GetServerSidePropsReturnType } from '../../relay/Common/PageProps';
import { ArticleType } from '../../graphql/generated/api-graphql';
import BugsnagHelpers from '../../helpers/BugsnagHelpers';
export async function getServerSideProps(context: GetServerSidePropsContext): GetServerSidePropsReturnType<ArticlePageProps> {
  try {
    const [rs, configurationRs] = await Promise.all([ssrPersistedQuery(article, {
      slug: context?.query?.slug
    }), ssrPersistedQuery(Configuration.queries.configuration)]);
    const {
      article: data,
      articles
    } = rs?.data ?? {};
    const configuration = configurationRs?.data ?? null;
    const i18n = initWithLangAndLabels('fr', {});
    if (!configuration || rs?.errors) {
      set503Header(context);
      return {
        props: {
          i18n,
          error: true
        }
      };
    }
    if (isMaintenance(configuration)) {
      set503Header(context);
    } else {
      setDefaultCacheHeader(context);
    }
    const notHealth = data?.__typename === 'CulinaryArticle' || data?.type === ArticleType.Cheese;
    if (!data || notHealth) {
      return {
        notFound: true,
        props: {
          i18n,
          configuration
        }
      };
    }
    return {
      props: {
        i18n,
        configuration,
        metas: transformSeoToMetas(Router.getRouteUrl(routes.healthArticle, {
          slug: context?.query?.slug
        }), data?.seo),
        data,
        articles: articles ?? null
      }
    };
  } catch (e: any) {
    BugsnagHelpers?.notify(e, event => {
      const {
        resolvedUrl,
        query,
        params
      } = context;
      event.addMetadata('context', {
        resolvedUrl,
        query,
        params
      });
    });
    setNoCacheHeader(context);
    return {
      notFound: true
    };
  }
}
export default ArticlePage;